import React, { useEffect, useState } from "react";
import { baseApiUrl } from "../../../services/api";
import "./footer.css";

function Footer() {
  const [categories, setCategories] = useState([]);
  const [liens, setLiens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Charger les catégories
  useEffect(() => {
    baseApiUrl
      .get("/categorie/liste")
      .then((response) => {
        // Vérifie si la réponse est bien un tableau
        const data = response.data;
        console.log("Catégories reçues :", data);

        if (Array.isArray(data)) {
          setCategories(data);
        } else if (Array.isArray(data.data)) {
          setCategories(data.data);
        } else {
          throw new Error("Format de données inattendu");
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des catégories :", error);
        setError("Erreur lors du chargement des catégories.");
        setLoading(false);
      });
  }, []);

  // Charger les liens utiles
  useEffect(() => {
    const fetchLiens = async () => {
      try {
        const response = await baseApiUrl.get("/liens-utiles");

        if (response.status !== 200) {
          throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const data = response.data;
        console.log("Liens utiles reçus :", data);

        if (Array.isArray(data)) {
          setLiens(data);
        } else if (Array.isArray(data.data)) {
          setLiens(data.data);
        } else {
          console.warn("Format inattendu pour les liens utiles.");
        }
      } catch (error) {
        console.error("Erreur lors du chargement des liens utiles:", error.message || error);
      }
    };

    fetchLiens();
  }, []);

  return (
    <footer className="footer-green">
      <div className="footer1 mt-85 md:mt-50 sm:mt-40">
        <div className="container">
          <div className="row">
            {/* Logo + Réseaux sociaux */}
            <div className="col-lg-3 col-md-6">
              <div className="logo">
                <a href="/">
                  <img src="assets/img/logo/ab2i.jpg" alt="ab2i logo" />
                </a>
              </div>
              <div className="heading1 mt-16">
                <p>.</p>
                <div className="footer-social1">
                  <ul>
                    <li><a href="https://www.facebook.com/AB2iBurkina"><i className="fa-brands fa-facebook-f"></i></a></li>
                    <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                    <li><a href="https://x.com/AB2Ibf"><i className="fa-brands fa-instagram"></i></a></li>
                    <li><a href="https://www.youtube.com/@AB2I-v7t"><i className="fa-brands fa-youtube"></i></a></li>
                    <li><a href="https://www.tiktok.com/@f.n.i.ib?lang=fr"><i className="fa-brands fa-tiktok"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Domaines */}
            <div className="col-lg-3 col-md-6 mb-50 sm:mb-30 sm:mt-30">
              <div className="footer-list1 ml-80 md:ml-0 sm:ml-0">
                <h3>Domaines</h3>
                {loading ? (
                  <div>Chargement...</div>
                ) : error ? (
                  <div>{error}</div>
                ) : (
                  <ul>
                    {Array.isArray(categories) && categories.length > 0 ? (
                      categories.map((category) => (
                        <li key={category.id}>
                          <a href="#">{category.nom}</a>
                        </li>
                      ))
                    ) : (
                      <li>Aucune catégorie disponible.</li>
                    )}
                  </ul>
                )}
              </div>
            </div>

            {/* Liens utiles */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-list1 ml-50 md:ml-0 sm:ml-0 mb-50 sm:mb-30">
                <h3>Liens Utiles</h3>
                <ul>
                  {Array.isArray(liens) && liens.length > 0 ? (
                    liens.map((lien, index) => (
                      <li key={index}>
                        <a href={lien.lien} target="_blank" rel="noopener noreferrer">
                          {lien.nom}
                        </a>
                      </li>
                    ))
                  ) : (
                    <li>Aucun lien utile trouvé.</li>
                  )}
                </ul>
              </div>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-contact-list1 mb-50 sm:mb-30">
                <h3>Nous Contactez</h3>
                <div className="footer-contact-box1">
                  <div className="icon">
                    <img src="assets/img/icons/footer1-icon1.svg" alt="email" />
                  </div>
                  <div className="text">
                    <a href="mailto:ab2iburkinafaso@gmail.com">ab2iburkinafaso@gmail.com</a>
                  </div>
                </div>
                <div className="footer-contact-box1">
                  <div className="icon">
                    <img src="assets/img/icons/footer1-icon2.svg" alt="location" />
                  </div>
                  <div className="text">
                    <a href="#">BURKINA FASO <br /> OUAGADOUGOU</a>
                  </div>
                </div>
                <div className="footer-contact-box1">
                  <div className="icon">
                    <img src="assets/img/icons/footer1-icon3.svg" alt="phone" />
                  </div>
                  <div className="text">
                    <a href="tel:+22670003555">+226 70 00 35 55</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="coppyrihgt1">
            <div className="row coppyrihgt-border">
              <div className="col-md-12 text-center">
                <p className="coppyrihgt">© 2024 AB2I. Tous droits réservés. Versiontest</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
